const IngasScripts = function IngasScripts() {
  $('.hero__scroll').on('click', () => {
    $('html, body').animate({
      scrollTop: $(window).height(),
    }, 1200);
  });
};

export default IngasScripts;
